import { Collapse, CollapseProps, Flex, Segmented, Typography } from 'antd';
import { AppstoreOutlined, BarsOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import './CollapseCustom.scss';
import { CollapsibleType } from 'antd/es/collapse/CollapsePanel';

const { Text } = Typography;

type PropsType = {
  title?: string;
  titleLevel?: 1 | 2 | 3 | 4 | 5;
  isSegmented?: boolean;
  items: CollapseProps['items'];
  bordered?: boolean;
  expandIconPosition: 'start' | 'end';
  className: string;
  ghost?: boolean;
  isFullDefault?: boolean;
  collapsible?: CollapsibleType | undefined;
};
const { Title } = Typography;

export enum SegmentedEn {
  FULL = 'full',
  LESS = 'less'
}

export default function CollapseCustom({
  title,
  titleLevel,
  isSegmented = true,
  items,
  bordered = false,
  expandIconPosition,
  className,
  ghost,
  isFullDefault,
  collapsible
}: PropsType) {
  const [expandKeys, setExpandKeys] = useState<string[]>([]);
  const [mode, setMode] = useState<SegmentedEn>(isFullDefault ? SegmentedEn.FULL : SegmentedEn.LESS);

  const handleChangeSegmented = (value: SegmentedEn) => {
    setMode(value);
  };

  useEffect(() => {
    if (mode === SegmentedEn.FULL) {
      setExpandKeys(items?.map((item) => item?.key) as string[]);
    } else {
      setExpandKeys([]);
    }
  }, [mode, items]);

  return (
    <Flex vertical className='collapse-custom-wrapper'>
      <Flex justify={title ? 'space-between' : 'flex-end'} align='center' className='collapse-custom-header'>
        {title &&
          (titleLevel ? (
            <Title level={titleLevel} className='collapse-custom-title'>
              {title}
            </Title>
          ) : (
            <Text strong>{title}</Text>
          ))}
        {isSegmented && (
          <Segmented
            size='small'
            value={mode}
            options={[
              {
                label: 'Thu gọn',
                value: 'less',
                icon: <BarsOutlined />
              },
              {
                label: 'Đầy đủ',
                value: 'full',
                icon: <AppstoreOutlined />
              }
            ]}
            onChange={(value) => handleChangeSegmented(value as SegmentedEn)}
          />
        )}
      </Flex>
      <Collapse
        activeKey={expandKeys}
        bordered={bordered}
        items={items}
        expandIconPosition={expandIconPosition}
        className={`collapse-custom ${className}`}
        onChange={(e) => setExpandKeys(e as string[])}
        ghost={ghost}
        collapsible={collapsible}
      />
    </Flex>
  );
}
